import { render } from "./GroupsIcon.vue?vue&type=template&id=03b653f4&scoped=true"
import script from "./GroupsIcon.vue?vue&type=script&lang=js"
export * from "./GroupsIcon.vue?vue&type=script&lang=js"

import "./GroupsIcon.vue?vue&type=style&index=0&id=03b653f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b653f4"]])

export default __exports__